export enum FilterGroupType {
  Checkbox = 'Checkbox',
  Range = 'Range',
  Category = 'Category',
}
